import templateStr from 'text!./activities-view.html';
import moment from 'moment';
import _ from 'lodash';
import JobUtil from 'edge/gateway/util/JobUtil';

export default ['$filter', 'ActivityService', 'ModalService', 'ViewModelService', 'InsuranceSuiteMetadata', ($filter, ActivityService, ModalService, ViewModelService, InsuranceSuiteMetadata) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            activities: '='
        },
        // replace: true,
        controller: ['$scope', '$q', 'GPA_PC_ENTRY_POINT', ($scope, $q, GPA_PC_ENTRY_POINT) => {
            const priorityTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('Priority');

            $scope.note = {
                subject: '',
                body: ''
            };

            $scope.jobUtil = JobUtil;

            $scope.noteView = ViewModelService.create($scope.note, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');


            $scope.openJobInXCenter = (jobNumber) => {
                JobUtil.openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber);
            };

            $scope.toggleAddNoteForm = (activity) => {
                resetNoteView();
                activity.addNoteFormVisible = angular.isDefined(activity.addNoteFormVisible) ? !activity.addNoteFormVisible : true;
            };

            $scope.saveNote = (activity, form) => {
                form.submitted = true;
                if (form.invalid) {
                    return;
                }
                $scope.note.topic_PSA = $scope.note.topic;
                $scope.note.relatedTo = $scope.note.topic;
                const createActivityNotePromise = ActivityService.createNoteForActivity(activity.publicID, $scope.note);
                $scope.createActivityNotePromise = createActivityNotePromise;

                $q.when(
                    createActivityNotePromise,
                    (createdNote) => {
                        $scope.toggleAddNoteForm(activity);
                        ModalService.showInfo('gateway.directives.activity-schedule.Done', 'gateway.directives.activity-schedule.Note created');
                        activity.notes.push(createdNote);
                        activity.notes.sort((a, b) => {
                            return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                        });
                        $scope.$emit('noteAdded', activity.notes);
                        resetNoteView();
                    },
                    () => {
                        ModalService.showError('gateway.directives.activity-schedule.Error', 'gateway.directives.activity-schedule.Failed to create note', '');
                    }
                );
            };

            function resetNoteView() {
                $scope.noteView.subject.value = '';
                $scope.noteView.topic.value = '';
                $scope.noteView.body.value = '';
            }

            $scope.toggleActivity = (activity) => {
                activity.expanded = angular.isDefined(activity.expanded) ? !activity.expanded : true;
            };

            $scope.sortNotes = (activity) => {
                return activity.notes.sort((a, b) => {
                    return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                });
            };

            $scope.showNotes = (activity) => {
                activity.showNotes = angular.isDefined(activity.showNotes) ? !activity.showNotes : true;
            };

            $scope.sortNotes = (activity) => {
                return activity.notes.sort((a, b) => {
                    return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                });
            };

            $scope.isOverdue = (dueDate) => {
                return moment(dueDate).isBefore(moment(), 'd');
            };

            $scope.isCompleted = (status) => {
                return status === 'complete';
            };


            $scope.noDueDateToTop = (activity) => {
                return (angular.isDefined(activity.dueDate) ? 0 : -1);
            };

            $scope.competeActivity = (anActivity) => {
                const markActivityAsCompletedPromise = ActivityService.markActivityAsCompleted(anActivity.publicID);

                markActivityAsCompletedPromise.then(
                    (activity) => {
                        anActivity.status = activity.status;
                        anActivity.closeDate = activity.closeDate;
                        anActivity.completedDate = activity.completedDate;
                        anActivity.expanded = false;
                        $scope.$emit('activityCompleted');
                        $scope.$emit('activitiesUpdated', _.filter($scope.$parent.activities, {status: 'open'}));
                    },
                    () => {
                        ModalService.showError('Error', 'Could not mark this Activity as complete.');
                    }
                );
            };

            $scope.getPriorityDisplayName = (priority) => {
                return priorityTypelist.getCode(priority).name;
            };
        }]
    };
}];